import React, {PropTypes} from 'react';
import DivisionItemFormContainer from './DivisionItemFormContainer.jsx';
import DivisionItem from './DivisionItem.jsx';

const DivisionList = ({
  entries,
  onDivisionClick
}) => (
  <div className="list-group">
    {entries.map((item, index) => (
      <div key={index}>
        <DivisionItem
          {...item}
          onClick={onDivisionClick}
        />
        {
          item.editing
          ? <DivisionItemFormContainer />
          : null
        }
      </div>
    ))}
  </div>
);

DivisionList.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.object),
  onDivisionClick: PropTypes.func
};

export default DivisionList;



// WEBPACK FOOTER //
// ./src/features/tournament/divisions/DivisionList.jsx